/**
 * Valida se um número de CNPJ é válido de acordo com o algoritmo de dígitos verificadores.
 * @param cnpj O CNPJ a ser validado (pode conter pontuação).
 * @returns true se o CNPJ for válido, false caso contrário.
 */
export var isValidCNPJ = function (cnpj) {
    if (!cnpj)
        return false;
    // Remove caracteres não numéricos
    var numbers = cnpj.replace(/[^\d]+/g, "");
    if (numbers.length !== 14)
        return false;
    // Elimina CNPJs com todos os dígitos iguais (ex: 00000000000000)
    if (/^(\d)\1+$/.test(numbers))
        return false;
    // Validação dos dois dígitos verificadores
    var validateDigit = function (t, digitCount) {
        var sum = 0;
        var pos = digitCount - 7;
        for (var i = digitCount; i >= 1; i--) {
            sum += parseInt(t.charAt(digitCount - i)) * pos--;
            if (pos < 2)
                pos = 9;
        }
        var result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
        return result === parseInt(t.charAt(digitCount));
    };
    // Valida 1º dígito
    if (!validateDigit(numbers, 12))
        return false;
    // Valida 2º dígito
    return validateDigit(numbers, 13);
};
/**
 * Valida se um número de CPF é válido de acordo com o algoritmo de dígitos verificadores.
 * @param cpf O CPF a ser validado (pode conter pontuação).
 * @returns true se o CPF for válido, false caso contrário.
 */
export var isValidCPF = function (cpf) {
    if (!cpf)
        return false;
    // Remove caracteres não numéricos
    var numbers = cpf.replace(/[^\d]+/g, "");
    if (numbers.length !== 11)
        return false;
    // Elimina CPFs com todos os dígitos iguais (ex: 00000000000)
    if (/^(\d)\1+$/.test(numbers))
        return false;
    var validateDigit = function (t, length) {
        var sum = 0;
        for (var i = 1; i <= length; i++) {
            sum += parseInt(t.substring(i - 1, i)) * (length + 2 - i);
        }
        var rest = (sum * 10) % 11;
        var digit = rest === 10 || rest === 11 ? 0 : rest;
        return digit === parseInt(t.substring(length, length + 1));
    };
    // Valida 1º dígito
    if (!validateDigit(numbers, 9))
        return false;
    // Valida 2º dígito
    return validateDigit(numbers, 10);
};
